import { ThemeDefinition } from "vuetify";

export const chorusTheme: ThemeDefinition = {
  dark: false,
  colors: {
    "background": "#f3f3f3", // View background
    "surface": "#ffffff", // Navbar
    "surface-secondary": "#FBFCFD",
    "primary": "#408A51",
    "btn-primary": "#F0B67F",
    "btn-secondary": "#3A3A3A",
    "btn-icon": "#FBFCFD",
    "card": "#252B33",
    "card-subtitle": "#38404A",
    "subtle": "#F6F8FA",
    "on-subtle": "#38404A",
    "subtle-border": "#E0E5EB",
    "error": "#A82222",
    "disconnect": "#C94040",
    "required": "#A24613",
    "success": "#17825A",
    "on-background": "#424242",
    "on-surface": "#424242",
    "navbar": "#2f011f",
    "navbar-selected": "#424242",
    "bg-navbar-selected": "#EEEEEE",
    "background-navbar-selected": "#EEEEEE",
    "on-navbar-selected": "#424242",
    "anchor": "#1346A2",
    "anchor-hover": "#ff46A2",
    "title": "#161A20",
    "subtitle": "#4F5864",
    "bg-login-button": "#f0b67f",
    "footer-background-color": "#408A51",
    "footer-link-text-color": "#ffffff",
    "footer-login-link-text-color": "#353535",
    "card-icon-bg": "#F6F8FA",
    "navigation-icon": "#38404A",
    "surface-variant": "#FFFFFF",
    "on-surface-variant": "#000000",
    "recently-added": "#F2FBF5",
    "progress-bar": "#E3A72F",
    "progress-bar-bg": "#17825A",
    "details": "#687384",
    "active-integration-background-color": "#BFF2D0",
    "classlink": "#0a4d7f",
    "google-login-button": "#F2F2F2",
    "adopt-request-bar": "#FFF9E8",
  }
};
